// Work Experience Data

export const workExperience = [
  {
    company: "iRIS Health",
    title: "Senior AI Engineer",
    url: "https://www.iris-sim.com/",
    location: "Remote",
    range: "Oct 2024 - Present",
    description: "Leading AI development for a production-grade healthcare simulation platform focused on realistic clinical scenarios and clinician productivity.",
    duties: [
      "Led end-to-end AI development for a scenario-based clinical simulation product",
      "Designed AI-generated clinical scenario workflows tailored to real-world patient situations",
      "Built an ABG (Arterial Blood Gas) generator to simulate realistic lab values aligned with clinical context",
      "Developed AI-driven assessment checklist generation to standardize clinical evaluations",
      "Designed RAG pipelines to ensure AI responses remain grounded in medical guidelines",
      "Focused on reliability and predictable AI behavior in safety-critical healthcare use cases"
    ],
    technologies: ["Python", "FastAPI", "LLMs", "LangChain", "PostgreSQL", "Redis", "Docker", "Vector DBs"]
  },
  {
    company: "Upwork",
    title: "Freelance AI Engineer",
    url: "https://www.upwork.com/",
    location: "Remote",
    range: "Jan 2024 - Present",
    description: "Delivering custom AI and LLM-based solutions for global clients, focusing on reliability and real business impact.",
    duties: [
      "Designed and delivered AI-powered chatbots tailored to client-specific domains",
      "Built Retrieval-Augmented Generation (RAG) systems to ground LLM outputs in private data",
      "Engineered prompts and response pipelines for accuracy and controllability",
      "Integrated AI systems with backend services, databases, and APIs",
      "Communicated technical trade-offs clearly to non-technical stakeholders"
    ],
    technologies: ["Python", "LangChain", "RAG", "AWS", "PostgreSQL", "FastAPI", "Vector DBs"]
  },
  {
    company: "Avinashi",
    title: "AI Engineer",
    url: "https://www.avinashi.ai/",
    location: "India",
    range: "Jun 2024 - Oct 2024",
    description: "Worked on applied AI solutions with a focus on conversational systems and intelligent automation.",
    duties: [
      "Developed AI-based conversational flows tailored to specific business use cases",
      "Worked on NLP-driven automation to reduce manual operational workload",
      "Translated loosely defined requirements into functional AI system designs",
      "Validated AI outputs for correctness, relevance, and user experience"
    ],
    technologies: ["Python", "NLP", "LLM APIs", "Prompt Engineering", "FastAPI"]
  },
  {
    company: "La Net Team",
    title: "Junior Data Scientist",
    url: "https://www.lanetteam.com/",
    location: "India",
    range: "May 2022 - Dec 2023",
    description: "Delivered production-grade machine learning and NLP systems, spanning model development to chatbot engineering.",
    duties: [
      "Designed and trained NLP models for sentiment analysis and bias detection using PyTorch",
      "Built AI-powered chatbots to automate customer support and installation queries",
      "Developed end-to-end ML pipelines including data ingestion, training, and inference",
      "Collaborated with backend engineers to integrate ML models into production APIs",
      "Applied RFM analysis for customer segmentation and behavioral insights"
    ],
    technologies: ["Python", "PyTorch", "Pandas", "Scikit-learn", "spaCy", "REST APIs"]
  },
  {
    company: "DevTown",
    title: "Data Scientist Intern",
    url: "https://www.devtown.in/",
    location: "India",
    range: "Jun 2021 - Aug 2021",
    description: "Completed an intensive ML bootcamp focused on building strong foundations in data science and applied machine learning.",
    duties: [
      "Built end-to-end ML projects applying supervised and unsupervised learning techniques",
      "Performed exploratory data analysis to identify patterns and data quality issues",
      "Implemented model training and validation workflows using Python libraries",
      "Collaborated in live sessions to review solutions and discuss ML trade-offs"
    ],
    technologies: ["Python", "NumPy", "Pandas", "Scikit-learn", "Matplotlib"]
  }
];
